import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=e0534678"
import script from "./pc.vue?vue&type=script&lang=ts"
export * from "./pc.vue?vue&type=script&lang=ts"
import style0 from "./pc.vue?vue&type=style&index=0&id=e0534678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports